module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": "",
      "permanent": this.$vuetify.breakpoint.lgAndUp,
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items()), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "exact": "",
        "href": item.href,
        "to": item.route
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.badge && item.badge > 0),
        expression: "item.badge && item.badge > 0"
      }],
      attrs: {
        "right": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(item.badge))]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-title', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.badge || item.badge === 0),
        expression: "!item.badge || item.badge === 0"
      }],
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "width": "100%"
    },
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.sendSuggestion
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mail_outline")]), _vm._v("Предложения")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.sendError
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("error_outline")]), _vm._v("Замечания")], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "text-xs-center": "",
      "xs12": ""
    }
  }, [_vm._v("\n       ©2016-2026 OOO \"БВР\"\n      ")])], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "fixed": "",
      "app": "",
      "dark": "",
      "clipped-left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": _vm.getOpenSettings.env !== 'test' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/logo.png",
      "height": "32px"
    }
  })]), _vm._v(" "), _c('v-toolbar-title', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getIsMobile),
      expression: "!getIsMobile"
    }],
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getIsMobile),
      expression: "!getIsMobile"
    }]
  }, [_vm._v(_vm._s(_vm.profile.clientNameShort))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogged()),
      expression: "!isLogged()"
    }],
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/login')
      }
    }
  }, [_vm._v("\n        Вход\n      ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged()),
      expression: "isLogged()"
    }],
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-badge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getActionBadgeValue > 0),
      expression: "getActionBadgeValue > 0"
    }],
    attrs: {
      "overlap": "",
      "color": _vm.getActionBadgeColor
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.getActionBadgeValue))]), _vm._v("\n                  " + _vm._s(_vm.profile.nameShort) + "\n                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getActionBadgeValue),
      expression: "!getActionBadgeValue"
    }]
  }, [_vm._v(_vm._s(_vm.profile.nameShort))]), _vm._v(" "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.profileMenu), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.$router.push(item.route)
        }
      }
    }, [_c('v-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.badge && item.badge > 0),
        expression: "item.badge && item.badge > 0"
      }],
      attrs: {
        "right": "",
        "color": item.badgeColor
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(item.badge))]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-title', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.badge || item.badge === 0),
        expression: "!item.badge || item.badge === 0"
      }],
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-title', [_vm._v("Выход")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-snackbar', {
    attrs: {
      "value": _vm.alertShow,
      "top": "",
      "auto-height": "",
      "color": _vm.getAlertColor,
      "multi-line": "",
      "timeout": _vm.getAlertTimeout
    },
    on: {
      "input": _vm.onCloseAlert
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "-24px"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.showDetails,
      "caption": _vm.showDetails ? 'Кратко' : 'Подробно',
      "expandable": _vm.expandDetails,
      "primary": false
    },
    on: {
      "click": function($event) {
        _vm.showDetails = !_vm.showDetails
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_vm._v("\n          " + _vm._s(_vm.status.message) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.onCloseAlert
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticStyle: {
      "display": "block",
      "overflow": "auto",
      "overflow-wrap": "break-word",
      "color": "rgba(0,0,0,0.87)",
      "background-color": "white"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.status.details)
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('v-modal-factory', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged()),
      expression: "isLogged()"
    }],
    ref: "modal"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297bbcaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 979
// module chunks = 1